import {CurrencyRate, CurrencyRates} from '../types/CurrencyRates';

export function ensureCurrencyRate($currency: Currency, $currencyCode: string): CurrencyRate {
    return $currency.rates[$currencyCode] || {rate: 0, fee: 0, feePercent: 0};
}

export type Currency = {
    code: string,
    codeLabel: string,
    name: string,
    protocol: string,
    /** @deprecated */
    symbol: string,
    type: 'crypto' | 'fiat' | 'internal',

    rates: CurrencyRates,
    to: Array<string>,
    from: Array<string>,
};
